'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CometSpin = require('./CometSpin');

var _CometSpin2 = _interopRequireDefault(_CometSpin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CometSpinLoader = function CometSpinLoader(props) {
  return _react2.default.createElement(_CometSpin2.default, props);
};

CometSpinLoader.propTypes = {
  color: _propTypes2.default.string,
  duration: _propTypes2.default.number,
  size: _propTypes2.default.number
};

CometSpinLoader.defaultProps = {
  color: '#000',
  duration: 1.7,
  size: 90
};

exports.default = CometSpinLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-loaders2/dist/comet-spin/CometSpinLoader.js
// module id = 554
// module chunks = 0